module.exports = __webpack_public_path__ + "img/logo.cdcd7988.png";